import * as React from 'react';
import {connect} from 'react-redux';
import {IconButton} from './iconbutton';
import {Subheading} from './subheading';
import LocationFilter from './locationfilter';
import {Card, CardHeader, CardBody, CardActions} from './cards';
import {ExportModal} from './modals';
import {SubscribeModal} from './modals';
import {LocationFilterLevel} from '../model/geo';
import {Paginator} from './paginator';
import * as Locale from '../model/locale';
import {V2Premises} from '../model/premises';
import {loadCabinetExport} from '../model/reports';
import {appRoutes} from '../model/routes/main';
import LoadingPane from './loadingpane';
import {updateUserSettings, setContactModalValidationErrors} from "../model/account";
import * as _ from 'underscore';
import {getSensorsDataInMultiples, updateCabinetDashboardDisplay, updateCabinetSubscribeDisplay} from "../model/cabinets";


export interface CabinetListProps {
    unitId: string;
    location?: any;
    dispatch?: Function;
    textForKey?: Function;
    loading: boolean;
    user: any;
    viewType: any;
    history: any;
    data: any;
    premisesUnits: any;
    ui: any;
    contactModalValidationErrors: any;
    units: any;
    sensors: any;

}

export function subscribeButtonClass(ui, cabinet) {
    let className = 'btn-subscribe';
    if (ui.isSubscribing) {
        return className + ' icon-loading';
    }
    if (cabinet.subscribed) {
        return className + ' activated';
    }
    return className;
}

export function dashboardAddButtonClass(ui, cabinet) {
    let className = 'btn-dashboard-add';
    if (ui[cabinet.unit_id] && ui[cabinet.unit_id].settingDashboardDisplay) {
        return className + ' icon-loading';
    }
    if (cabinet.dashboard_display) {
        return className + ' activated';
    }
    return className;
}
@connect(
    state => ({
        ui: state.ui,
        contactModalValidationErrors: state.ui.accounts.contactModal.validationErrors,
        textForKey: state.data.textForKey,
        premisesUnits: state.data.premisesUnits,
        loading: state.ui.premisesUnits.loading || state.ui.geo.loading,
        user: state.data.user,
        data: state.data,
        units: state.data.units,
        sensors: state.data.sensors,
    })
)

export class CabinetList extends React.Component<CabinetListProps, any> {
    componentWillUpdate(nextProps, nextState) {
        let {user} = this.props,
            {units, sensors} = nextProps;
        let allUnitsPresent = _.every(units.results, function (unit: any) {
            return sensors[unit.unit_id];
        });
        if (!allUnitsPresent && !(nextProps.ui.sensors.readingsLoading)) {
            this.props.dispatch(getSensorsDataInMultiples(units.results, user.language));
        }
    }
    render() {
        const {loading, textForKey} = this.props;

        if (loading) {
            return <LoadingPane title={textForKey(Locale.TEXT_NAVIGATION_CABINETS)}/>;
        }
        return this.buildPageContent();
    }
    private buildPageContent() {
        const {textForKey} = this.props;
        return (
            <div className="container content cabinetsPage">
                <Subheading title={textForKey(Locale.TEXT_HEADER_CABINETS)}>
                    {this.buildLocationFilter()}
                </Subheading>
                <div className="cards card-view">
                    {this.buildCabinetCards()}
                </div>
                {this.buildPagination()}
            </div>
        );
    }
    private buildLocationFilter() {
        const {location, history} = this.props;
        let locationfilterProps = {
            filterLevel: LocationFilterLevel.Country,
            stores: this.props.data.premises,
            location,
            history
        };

        return <LocationFilter {...locationfilterProps} />;
    }

    private buildCabinetCards() {
        let {units, ui, user, textForKey, dispatch, contactModalValidationErrors, sensors} = this.props;
        return units.results.map(cabinet => {
            let cabinetProps = {
                cabinet, textForKey, ui: {
                    readingsLoading: ui.sensors.readingsLoading || false,
                    contactModalValidationErrors,
                    settingDashboardDisplay: (ui.cabinets[cabinet.unit_id] ?
                        ui.cabinets[cabinet.unit_id].settingDashboardDisplay : false),
                    isSubscribing: (ui.cabinets[cabinet.unit_id] && ui.cabinets[cabinet.unit_id].isSubscribing),
                    updateUserAction: (card: CabinetCard, data: any) => {
                        dispatch(updateUserSettings(data))
                            .then(() => {
                                card.closeContactDetails();
                                dispatch(updateCabinetSubscribeDisplay(cabinet.unit_id, !cabinet.subscribed));
                            })
                            .catch(error => {
                                dispatch(setContactModalValidationErrors(null));
                                if (!_.isEmpty(error.data)) {
                                    dispatch(setContactModalValidationErrors(error.data));
                                }
                            });
                    },
                    subscribeAction: (card: CabinetCard) => {
                        // if saved details
                        if (!cabinet.subscribed && user.email.length === 0 && user.mobile.length === 0) {
                            // do modal popup
                            card.openContactDetails();

                        } else {
                            dispatch(updateCabinetSubscribeDisplay(cabinet.unit_id, !cabinet.subscribed));
                        }

                    },
                    exportAction: (startDate, endDate, reportType, exportSensors) => {
                        return dispatch(loadCabinetExport(
                            cabinet, startDate, endDate, user.language, reportType, exportSensors
                        ));
                    }
                }, dispatch, sensors
            };
            return (
                <CabinetCard key={cabinet.unit_id} {...cabinetProps} />
            );
        });
    }

    private buildPagination() {
        let {units, location} = this.props;
        return <Paginator itemsPerPage={15}
                          totalItems={units.count}
                          location={location}
                          page={parseInt(location.query.page || 1, 10)}
                          route={appRoutes.react_cabinets}
                          maxVisible={5} />;
    }
}
interface CabinetCardDataProps {
    premises: V2Premises;
}
interface CabinetCardUiProps {
    link: string;
    subscribeAction: (card: CabinetCard) => void;
    dashboardAction: () => void;
    exportAction: (startDate, endDate, reportType, sensors) => void;
    getUnitsAction: () => void;
    isSubscribing: boolean;
    settingDashboardDisplay: boolean;
    updateUserAction: (card: CabinetCard, data: any) => void;
    contactModalValidationErrors: { [input: string]: string[] };
}

interface CabinetCardProps extends React.Props<CabinetCardProps> {
    cabinet?: any;
    ui?: any;
    textForKey?: Function;
    premisesUnits?: any;
    sensorsLoading?: any;
    dispatch?: Function;
    sensors?: any;
    data?: any;
    user?: any;
}
interface CabinetCardState {
    showExport: boolean;
    showContact: boolean;
}

export class CabinetCard extends React.Component<CabinetCardProps, CabinetCardState> {
    state: {
        showExport: boolean;
        showContact: boolean;
    };

    constructor() {
        super();
        this.state = { showExport: false, showContact: false };
    }

    openExport() {
        this.setState({ showExport: true, showContact: false });

    }

    closeExport() {
        this.setState({ showExport: false, showContact: false});
    }

    openContactDetails() {

        this.setState({ showContact: true, showExport: false });
    }

    closeContactDetails() {
        this.setState({ showContact: false, showExport: false });
    }

    displaySensor(description, readings, cabinet) {
        let latest = readings.latestReadings;
        if (!latest) {
            return this.props.textForKey(Locale.TEXT_NA);
        }
        if (cabinet.model.includes("DOOR")) {
            return latest[description.key] ?
                this.props.textForKey(Locale.TEXT_CLOSED) :
                this.props.textForKey(Locale.TEXT_OPEN);
        }
        return latest[description.key] ?
            latest[description.key] + description.unit_of_measurement.um_abbreviated :
            this.props.textForKey(Locale.TEXT_NA);
    }

    getSensors(cabinet){
        let cardSensors = [],
            totalSensorsCount = 0;
        do {
            cardSensors.push(cabinet.sensors.filter(s => s.enabled).map(description => {
                totalSensorsCount++;
                return <dl className="single-sensor">
                    <dt className="single-sensor-title">
                        {(cabinet.sensors.length > 3) && description["sensor_description"].length > 15 ?
                            description["sensor_description"].slice(0, 14) + "..." : description["sensor_description"] }
                    </dt>
                    <dd className="single-sensor-data">
                        {this.props.ui.readingsLoading || !this.props.sensors[cabinet.unit_id] || this.props.sensors[cabinet.unit_id].error
                            ? "--" : this.displaySensor(description, this.props.sensors[cabinet.unit_id].readings, cabinet)
                        }
                    </dd>
                </dl>;
            }));
        } while (cabinet = cabinet.child);
        let orderedSensors = _.flatten(cardSensors);
        orderedSensors = (orderedSensors.length == 0) ? [] : _.sortBy(orderedSensors, function (sensor: any) {
            //console.info(sensor.props.children[0].props.children);
            return sensor.props.children[0].props.children;
        });
        return (<div
            className={totalSensorsCount < 3 ? "less-then-3" : (totalSensorsCount < 6 ? "four-or-more" : "more-then-6")}>
            {orderedSensors}
        </div>);
    }

    render() {
        let {cabinet, ui, user} = this.props;
        let onDashboard = cabinet.dashboard_display;
        let dashboardTextKey = onDashboard ?
            Locale.TEXT_TOOLTIP_REMOVE_FROM_DASHBOARD :
            Locale.TEXT_TOOLTIP_ADD_TO_DASHBOARD;
        let dashboardAttrs = {
            className: dashboardAddButtonClass(ui, cabinet),
            tooltip: this.props.textForKey(dashboardTextKey),
            onClick: () => {
                this.props.dispatch(updateCabinetDashboardDisplay(cabinet.unit_id, !cabinet.dashboard_display));
            },
            activated: onDashboard,
            disabled: ui.settingDashboardDisplay
        };
        const dashboardAddBtn = <IconButton {...dashboardAttrs}/>;


        let alarmBtnClass = 'btn-alarm';
        if (cabinet.uncleared_alarms > 0) {
            alarmBtnClass += ' activated';
        }
        let subscribeAttrs = {
            className: subscribeButtonClass(ui, cabinet),
            tooltip: this.props.textForKey(Locale.TEXT_TOOLTIP_SUBSCRIBE),
            onClick:(() => {
                ui.subscribeAction(this);
            }).bind(this),
            dataItem: cabinet,
            activated: cabinet.subscribed,
            disabled: ui.isSubscribing
        };

        let subscribeProps = {
            state: {
                show: this.state.showContact,
                onHide: this.closeContactDetails.bind(this)
            },
            textForKey: this.props.textForKey,
            updateAction:((data: any) => ui.updateUserAction(this, data)).bind(this),
            validationErrors: ui.contactModalValidationErrors
        };

        let exportAttrs = {
            className: 'btn-export',
            tooltip: this.props.textForKey(Locale.TEXT_TOOLTIP_EXPORT),
            onClick: this.openExport.bind(this)
        };

        let exportProps = {
            textForKey: this.props.textForKey,
            state: {
                show: this.state.showExport,
                onHide: this.closeExport.bind(this),
                sensorChoices: this.props.sensors
            },
            getUnitsAction: null,
            premisesUnits: [cabinet],
            exportAction: ui.exportAction,
            user: user
        };
        let configureAttrs = {
            className: 'btn-configure',
            tooltip: this.props.textForKey(Locale.TEXT_CONFIGURATION),
            onClick: null,
        };
        let title = cabinet.description === "" ? cabinet.unit_id : cabinet.description;
        if (title.length > 15){
            title = title.slice(0,15) + "...";
        }
        let locality = ((cabinet.gateway.premises.locality === "") ? "" : (cabinet.gateway.premises.locality +  ", ") );
        let link = `${appRoutes.cabinetDetails.path}${cabinet.unit_id}`;
        return (
            <Card isParentCard={false}>
                <ExportModal ref="export" {...exportProps}/>
                <SubscribeModal ref="subscribe" {...subscribeProps}/>
                <CardHeader title={title}
                            titleClassName="column-name"
                            subtitle={cabinet.gateway.premises.street_address}
                            location={this.props.textForKey(Locale.TEXT_LOCALITY, {locality:locality, region:cabinet.gateway.premises.region.name})}
                            subtitleClassName="column-address"
                            button={dashboardAddBtn}
                            link={link}
                            />
                <CardBody>
                    <a href={link}>
                           <div className={"offline-holder " + ((cabinet.unit_offline || !cabinet.enabled) ?
                               "cabinet-offline" : "cabinet-offline-hide") }>
                               {!cabinet.enabled ? this.props.textForKey(Locale.TEXT_DISABLED) : this.props.textForKey(Locale.TEXT_OFFLINE)}
                        </div>
                    </a>
                    <a href={link} className="data">
                        {this.getSensors(cabinet)}
                    </a>
                </CardBody>
                <CardActions link={link}>
                    <IconButton href={`${appRoutes.alarms.path}?store_slug=${cabinet.gateway.premises.slug}&unit_id=${cabinet.unit_id}`}
                                className={alarmBtnClass}
                                tooltip={this.props.textForKey(Locale.TEXT_TOOLTIP_VIEW_ALARMS)}>
                        {cabinet.uncleared_alarms}
                    </IconButton>

                    <IconButton href={`${appRoutes.alarmConfig.path}#?cabinet=${cabinet.unit_id}`} {...configureAttrs}/>

                    <IconButton  {...subscribeAttrs}/>

                    <IconButton  {...exportAttrs} />
                </CardActions>
            </Card>
        );
    }
}
